export default "__VITE_ASSET__xsiEMyxa__"